import * as Yup from 'yup'
import { cmsQAWidgetItemValidationSchema } from './QAItem'

export const qaSchemaValidation = Yup.object().shape({
  content: Yup.object({
    cmsQAWidgetItems: cmsQAWidgetItemValidationSchema,
  }),
})
